export default __webpack_public_path__ + "static/media/arrow-left.5503f9f6.svg";